import React from 'react';
import ReactDOM from 'react-dom/client';
import Ecommerce from './Ecommerce/Ecommerce';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    <Ecommerce />
  
);
